
import {
    Action,
} from 'one-state';

import {
    SET,
    REINIT,
} from './types';
import {
    TimeSlotModal
} from './timeslotsmodal';

/**
 * Redux action creator to set the list
 * of time slots
 * @param timeslotsstate time slots information
 * @returns action instance
 */
export const setAction = (timeslotsstate: TimeSlotModal[]):
    Action<typeof SET, TimeSlotModal[]> => ({
        type: SET,
        payload: timeslotsstate,
    });
/**
 * Re-initialize the state
 * @returns action instance
 */
export const resetAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });

/**
 * Alias for setAction to match epic naming
 */
export const setTimeSlotsAction = setAction;

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof resetAction>;

